(function () {

    angular
        .module('smartertoolsApp')
        .filter('friendlyDate', friendlyDate);

    function friendlyDate() {
        return function (date, toLocal) {
            if (date === null)
                return '-';

            let m = moment.utc(date, 'YYYY-MM-DD H:mm');
            if (toLocal == 'true' || toLocal == true) {
                m = m.local();
            }
            return m.format('M/D/YYYY h:mm A');
        }
    }

})();